import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-menu-separator',
  standalone: true,
  templateUrl: './ui-menu-separator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiMenuSeparatorComponent {}
